import * as React from "react"
import {SetBookingBooker} from "../graphql/queries"
import {SaveResetButtons, SectionProps, UpdatableFormSection} from "./UpdateBookingWizard"
import {Form} from "semantic-ui-react"
import {GraphQL} from "../graphql"
import {errorUnionToEither} from "../graphql/errors"
import {Booker} from "../model/BookingTypes"
import {BookerField} from "./AddBookingWizard"

interface BookerSectionState {
  booker: Booker | null
  bookerFormOpen: boolean
}

export function BookerPickerSection(props: SectionProps) {
  const state: BookerSectionState = {
    booker: props.booking.booker,
    bookerFormOpen: false,
  }
  return (
    <UpdatableFormSection
      {...props}
      state={state}
      header="Booker"
      render={(params) => {
        const {state, mapState} = params
        const isAdmin = props.booker.isAdmin
        return (
          <>
            {state.booker || mapState ? (
              <BookerField
                label={null}
                modalStore={props.modalStore}
                booker={state.booker}
                disabled={props.disabled}
                isAdmin={isAdmin}
                onBooker={
                  mapState &&
                  ((booker) => {
                    mapState((state) => ({...state, booker}))
                  })
                }
                bookerFormOpen={state.bookerFormOpen}
                onBookerFormOpen={
                  mapState &&
                  ((open) => {
                    mapState((state) => ({...state, bookerFormOpen: open}))
                  })
                }
              />
            ) : (
              <i>None</i>
            )}
            {mapState && (
              <Form.Group>
                <SaveResetButtons
                  {...props}
                  disabled={state.bookerFormOpen}
                  onSave={async () => {
                    const ret = await props.modalStore.applyModal({
                      pending: ["Saving booker", "Saving booker..."],
                      error: (m) => ["Saving booker failed", m],
                      action: async () => {
                        const data = await GraphQL.mutate(SetBookingBooker, {
                          id: props.booking.id,
                          bookerId: state.booker ? state.booker.id : null,
                        })
                        return errorUnionToEither(data.setBookingBooker)
                      },
                    })
                    return ret.isRight()
                  }}
                />
              </Form.Group>
            )}
          </>
        )
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingBookerPickerSection.tsx